function downloadApp() {
  let ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf("micromessenger") != -1;
  if (isWeixin) {
    // location.href = '下载链接'
  }
}
export default downloadApp;
